export var PipelineDetailsModalMode = /*@__PURE__*/ (function (PipelineDetailsModalMode) {
    PipelineDetailsModalMode[PipelineDetailsModalMode["VIEW"] = 0] = "VIEW";
    PipelineDetailsModalMode[PipelineDetailsModalMode["EDIT"] = 1] = "EDIT";
    return PipelineDetailsModalMode;
})({});
